<template>
	<div class="job-factor-degrees-selection">
		<v-combobox
			class="custom-combobox-bordered"
			label="Seleccionar Grado"
			:items="degrees"
			v-model="localSelectedDegree"
			solo
		>
			<template slot="selection" slot-scope="{ item, parent, selected }">
				<div class="tw-flex tw-justify-between tw-w-full">
					<span class="text-primary">{{ item.name }}</span>
					<span class="job-factor-degrees-selection-rate-selected">{{ item.rate }}</span>
				</div>
			</template>
			<template slot="item" slot-scope="{ item }">
				<div class="job-factor-degrees-selection-item" :class="{selected: isSelectedDegree(item)}">
					<div class="tw-flex tw-items-center tw-h-full">
						<div class=" tw-flex tw-justify-between tw-w-full">
							<span class="job-factor-degrees-selection-name text-info">{{ item.name }}</span>
							<span class="job-factor-degrees-selection-rate">{{ item.rate }}</span>
						</div>
					</div>
				</div>
			</template>
		</v-combobox>
	</div>
</template>

<script>
import { VCombobox } from 'vuetify';
import { equals } from 'ramda';

export default {
	name: 'JobFactorDegreesSelection',
	components: { VCombobox },
	props: {
		degrees: {
			type: Array,
			default: () => [],
		},
		selectedDegree: {
			type: Object,
		},
	},
	data() {
		return {
			localSelectedDegree: undefined,
		};
	},
	methods: {
		isSelectedDegree(degree) {
			return equals(degree, this.localSelectedDegree);
		},
	},
	watch: {
		selectedDegree: {
			handler(newValue) {
				this.localSelectedDegree = newValue;
			},
			immediate: true,
		},
		localSelectedDegree: {
			handler(newValue) {
				this.$emit('degreeSelected', newValue);
			},
		},
	},
};
</script>

<style lang="scss">

// TODO: move these global styles to customization.css if is used for other component
.custom-combobox-bordered {
	margin: 14px 0 14px 14px;
	padding: 3px 18px 3px 14px;
	border-radius: 4px;
	border: solid 1.5px var(--app-color-primary);
	background-color: #fff;

	.v-input__slot {
		box-shadow: none !important;
		margin-bottom: 0 !important;
		.v-label.theme--light {
			color: var(--app-color-primary) !important;
		}
		.v-input__icon {
			i.theme--light {
				color: var(--app-color-primary) !important;
			}
		}
	}
	.v-text-field__details {
		display: none !important;
	}
}

.v-select-list.v-card.theme--light {
	border-radius: 8px;
}


.job-factor-degrees-selection-rate {
	padding: 0 10px;
	border-radius: 10px;
	border: solid 1.9px #545a54;
	display: flex;
	color: var(--app-color-info);
}

.job-factor-degrees-selection-rate-selected {
	padding: 2px 10px;
	border-radius: 10px;
	display: inline-block;
	background-color: var(--app-color-gray);
	color: var(--app-color-primary);
	font-weight: bold;
}
.text-primary {
	font-size: 1.2em;
}

.job-factor-degrees-selection-item {
	position: inline-block;
	left: 0;
	right: 0;
	bottom: 0;
	top: 0;
	padding: 0 16px;
	&.selected {
		background: rgba(0,0,0,0.04);
		.job-factor-degrees-selection-name {
			font-weight: bold;
			font-size: 1em;
		}
		.job-factor-degrees-selection-rate {
			border: solid 1.9px var(--app-color-primary);
			color: var(--app-color-primary);
		}
	}
}
.job-factor-degrees-selection{
width: 100%;
@media (max-width: 1400px) {
width: 80px;
}
}
</style>

<style lang="scss" scoped>
.job-factor-degrees-selection {
}
</style>



// WEBPACK FOOTER //
// src/modules/polls/components/custom/JobEvaluationPollPage/JobFactorDegreesSelection.vue